export interface ProductChangeLine {
    changeId: number;
    productChangeId: number;
    group: string;
    type: string;
    value: string | number | boolean;
}

export class ProductChangeLineBuilder {
    private changeId: number;
    private productChangeId: number;
    private group: string = "";
    private type: string = "";
    private value: string | number | boolean = "";

    withChangeId(changeId: number): ProductChangeLineBuilder {
        this.changeId = changeId;
        return this;
    }

    withProductChangeId(productChangeId: number): ProductChangeLineBuilder {
        this.productChangeId = productChangeId;
        return this;
    }

    withGroup(group: string): ProductChangeLineBuilder {
        this.group = group;
        return this;
    }

    withType(type: string): ProductChangeLineBuilder {
        this.type = type;
        return this;
    }

    withValue(value: string | number | boolean): ProductChangeLineBuilder {
        this.value = value;
        return this;
    }

    build(): ProductChangeLine {
        return {
            changeId: this.changeId,
            productChangeId: this.productChangeId,
            group: this.group,
            type: this.type,
            value: this.value
        };
    }
}